









































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Vue as VueClass, Watch } from 'vue-property-decorator'
import IconSync from '@/app/ui/assets/icon_sync.vue'
import IconWhatsApp from '@/app/ui/assets/ics_f_whatsapp.vue'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DataTableV2 from '@/app/ui/components/DataTableV2/index.vue'
import {
  DataObject,
  HeaderObject,
  SortValueObject,
} from '@/app/ui/components/DataTableV2/type'
import PickupController from '@/app/ui/controllers/PickupController'
import { Utils } from '@/app/infrastructures/misc'
import {
  PickupCRROTWV2BucketKey,
  PickupNfdGroup,
  PICKUP_CRROTW_V2_BUCKET_KEYS,
  AssignPickupBulkHistoryList,
  PickupAssignIds,
} from '@/domain/entities/Pickup'
import dayjs from 'dayjs'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import dayjsDuration from 'dayjs/plugin/duration'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import { DropDownLabelValue } from '@/app/ui/components/DropdownSelect/interface'
import DropdownCheckbox from '@/app/ui/components/DropdownCheckbox/index.vue'
import ModalExportLog from '../components/Modals/ModalExportLog.vue'
import ModalExportCRRNFD from '../components/Modals/ModalExportCRRNFD.vue'
import ModalSuccess from '../components/Modals/ModalSuccess.vue'
import WidgetDownload from '@/app/ui/components/WidgetDownload/index.vue'
import CrrnfdShipmentListModal from './components/CrrnfdShipmentListModal.vue'
import CrrnfdBulkAssignModal from './components/CrrnfdBulkAssignModal.vue'
import AscendingIcon from '@/app/ui/assets/ascending_icon.vue'
import ModalConfirmation from '../components/Modals/ModalConfirmation.vue'
import IconMultipleFile from '@/app/ui/assets/ics_o_multiple.vue'
import AssignPickupBulkHistoryModal from './components/AssignPickupBulkHistoryModal.vue'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import { FlagsAccount } from '@/feature-flags'

dayjs.extend(dayjsDuration)

const CRRNFD_BUCKET_STRIP_LABELS: Record<PickupCRROTWV2BucketKey, string> = {
  '0_1h': '0-1 Jam',
  '1_2h': '1-2 Jam',
  '2_3h': '2-3 Jam',
  '3_4h': '3-4 Jam',
  '4_5h': '4-5 Jam',
  '5_plus': '5++ Jam',
}

const CRRNFD_SHIPMENT_TYPE_LABELS: Record<string, string> = {
  delivery_order: 'Delivery Order',
  marketplace: 'Marketplace',
  customer: 'Customer App',
  corporate: 'Corporate',
  aggregator: 'Aggregator',
}

@Component({
  components: {
    IconSync,
    IconWhatsApp,
    Button,
    TextInput,
    DataTableV2,
    PaginationNav,
    LoadingOverlay,
    DropdownSelect,
    DropdownCheckbox,
    ModalExportLog,
    ModalExportCRRNFD,
    ModalSuccess,
    WidgetDownload,
    CrrnfdShipmentListModal,
    CrrnfdBulkAssignModal,
    AscendingIcon,
    ModalConfirmation,
    IconMultipleFile,
    AssignPickupBulkHistoryModal,
    EyeIcon,
    EyeDisabledIcon
  },
})
class PickupCRRNFDList extends VueClass {
  controller = PickupController

  crrnfdBucketKeys = PICKUP_CRROTW_V2_BUCKET_KEYS
  crrnfdBucketStripLabels = CRRNFD_BUCKET_STRIP_LABELS

  crrnfdTableSlotNames = [
    'checkbox',
    '',
    'sender',
    'totalkoli',
    'jenisshipment',
    'lastcourier',
    'address',
    'crrnfddate',
    'crrnfddur',
    'cancelreason',
    'nfdstatus',
    'atur',
  ]

  headers = [
    this.headerCellMapper('', '32px'),
    this.headerCellMapper('No.', '60px'),
    this.headerCellMapper('Nama pengirim', '200px', true, 'sender_name', '20px'),
    this.headerCellMapper('Total Shipment (koli)', '160px', false, 'total_shipments', '16px'),
    this.headerCellMapper('Jenis Shipment', '150px'),
    this.headerCellMapper('Nama kurir terakhir', '190px'),
    this.headerCellMapper('Alamat', '240px'),
    this.headerCellMapper('Tanggal CRRNFD', '176px', false, 'crrnfd_at', '20px'),
    this.headerCellMapper('Durasi CRRNFD', '160px', false, 'crrnfd_duration_minute', '16px'),
    this.headerCellMapper('Alasan pembatalan', '214px'),
    this.headerCellMapper('NFD status terbanyak', '160px', false, 'crrnfd_iteration', '16px'),
    this.headerCellMapper('Atur', '64px'),
  ]

  shipmentTypeOptions = [
    { label: 'Marketplace (MP)', value: 'marketplace' },
    { label: 'Customer Apps (CA)', value: 'customer' },
    { label: 'Aggregator (C1)', value: 'aggregator' },
  ]

  durationBucketOptions: DropDownLabelValue<string>[] = [
    { label: 'Semua durasi', value: 'all' },
    { label: '0-1 Jam', value: '0_1h' },
    { label: '1-2 Jam', value: '1_2h' },
    { label: '2-3 Jam', value: '2_3h' },
    { label: '3-4 Jam', value: '3_4h' },
    { label: '4-5 Jam', value: '4_5h' },
    { label: '5++ Jam', value: '5_plus' },
  ]

  parameters = {
    page: 1,
    perPage: 10,
    search: '',
    shipmentType: [] as string[],
    durationBucket: {
      label: 'Semua durasi',
      value: 'all',
    } as DropDownLabelValue<string>,
    sort: {
      name: 'crrnfd_at',
      direction: 'DESC',
    },
  }

  tableData: DataObject[][] = []
  showModalExportLog = false
  showModalExportCRRNFD = false

  selectedShipperHashes: string[] = []
  shipperHash = ""

  openAturMenuShipperHash: string | null = null
  openAturMenuShipmentType: string | null = null
  private aturMenuTriggerEl: HTMLElement | null = null
  aturMenuFixedStyle: Record<string, string> = {}
  private aturTableScrollEl: Element | null = null
  private readonly aturMenuMinWidthPx = 200
  modalCRRSRCVisible = false
  modalAssignPickupBulkVisible = false

  private boundRepositionAturMenu = (): void => {
    this.updateAturMenuFixedPosition()
  }

  shipmentListModalVisible = false
  shipmentListModalShipperHash = ''

  bulkAssignModalVisible = false
  bulkAssignSubmitting = false

  modalSuccessCRRSRCVisible = false

  created(): void {
    this.fetchPickup(true)
    this.fetchAssignPickupBulkHistoryList()
  }

  mounted(): void {
    document.addEventListener('click', this.closeAturMenus)
    window.addEventListener('resize', this.boundRepositionAturMenu)
    window.addEventListener('scroll', this.boundRepositionAturMenu, true)
  }

  beforeDestroy(): void {
    document.removeEventListener('click', this.closeAturMenus)
    window.removeEventListener('resize', this.boundRepositionAturMenu)
    window.removeEventListener('scroll', this.boundRepositionAturMenu, true)
    this.unbindAturTableScrollListener()
  }

  get summaryBuckets(): Record<PickupCRROTWV2BucketKey, number> {
    return this.controller.pickupNfdSummary.buckets
  }

  get nfdTotalItems(): number {
    return this.controller.pickupNfdList.pagination?.totalItem ?? 0
  }

  get pageShipperHashes(): string[] {
    return (this.controller.pickupNfdList.data ?? []).map(g => g.shipperHash)
  }

  get isAllPageSelected(): boolean {
    const ids = this.pageShipperHashes
    return (
      ids.length > 0 &&
      ids.every(h => this.selectedShipperHashes.includes(h))
    )
  }

  get isSomePageSelected(): boolean {
    const ids = this.pageShipperHashes
    return ids.some(h => this.selectedShipperHashes.includes(h))
  }

  get headerCheckboxIndeterminate(): boolean {
    return this.isSomePageSelected && !this.isAllPageSelected
  }

  get bulkAssignSelectionTotals(): {
    totalShipments: number
    totalKoli: number
  } {
    const selected = new Set(this.selectedShipperHashes)
    const rows = this.controller.pickupNfdList.data ?? []
    let totalShipments = 0
    let totalKoli = 0
    for (const g of rows) {
      if (selected.has(g.shipperHash)) {
        totalShipments += Number(g.totalShipments) || 0
        totalKoli += Number(g.totalQuantity) || 0
      }
    }
    return { totalShipments, totalKoli }
  }

  get isMyWhitelist() {
    return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled();
  }

  @Watch('isMyWhitelist')
  isMyWhitelistChanged() {
    this.fetchPickup(true);
  }

  get nfdListParams(): Record<string, string | number | boolean | undefined> {
    const shipmentType = this.parameters.shipmentType
      .map(
        label =>
          this.shipmentTypeOptions.find(option => option.label === label)?.value
      )
      .filter(Boolean)
      .join(',')

    const db = this.parameters.durationBucket?.value
    return {
      page: this.parameters.page,
      perPage: this.parameters.perPage,
      q: this.parameters.search.trim(),
      shipmentType,
      durationBucket:
        db && db !== 'all' && db !== 'undefined' ? String(db) : undefined,
      orderBy: this.parameters.sort.name,
      sort: this.parameters.sort.direction,
      originCountry: this.isMyWhitelist ? 'Malaysia' : ''
    }
  }

  get latestSync(): string {
    if (!this.controller.latestSync) {
      return ''
    }

    return `${dayjs(this.controller.latestSync).format(
      'DD-MM-YY, HH:mm'
    )} WIB`
  }

  public onToolbarSyncClick(): void {
    this.fetchPickup(true)
  }

  public onShipmentTypeFilterInput(): void {
    this.fetchPickup(true)
  }

  public onDurationBucketFilterInput(): void {
    this.fetchPickup(true)
  }

  private headerCellMapper(
    title: string | number,
    colWidth: string,
    withSort?: boolean,
    sortName?: string,
    sortWidth?: string
  ): HeaderObject {
    return {
      title: <string>title,
      customStyle: {
        minWidth: colWidth,
        maxWidth: colWidth,
      },
      withSort,
      sortName: sortName,
      sortStyle: {
        marginLeft: sortWidth,
      },
    }
  }

  private tableCellMapper(value: unknown, colWidth: string, paddingRight?: string): DataObject {
    const customStyle = {
      maxWidth: colWidth,
      minWidth: colWidth,
      paddingRight: paddingRight || '8px',
    }
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      const o = value as DataObject
      return {
        ...o,
        customStyle: { ...customStyle, ...o.customStyle },
      } as DataObject
    }
    return {
      value: value as DataObject['value'],
      customStyle,
    }
  }

  public onDataTableSort(val: SortValueObject): void {
    this.parameters.sort = {
      name: val.name ?? '',
      direction: val.direction ?? 'DESC',
    }
    this.fetchPickup(true)
  }

  public onPaginationPageInput(): void {
    this.fetchPickup()
  }

  public onPaginationPerPageChange(val: number): void {
    this.parameters.perPage = Number(val)
    this.fetchPickup(true)
  }

  public async fetchPickup(reset = false): Promise<void> {
    if (reset) {
      this.parameters.page = 1
      this.selectedShipperHashes = []
      this.closeAturFlyout()
    }

    try {
      this.controller.setIsLoadingCRRNFD(true)
      const nfdParams = this.nfdListParams
      await Promise.all([
        this.controller.fetchPickupNfdList(nfdParams),
        this.controller.fetchPickupNfdSummary(nfdParams),
      ])
      this.controller.setLatestSync(new Date().toISOString())
    } finally {
      this.controller.setIsLoadingCRRNFD(false)
    }
  }

  public onSearch = Utils.debounce(() => {
    this.fetchPickup(true)
  }, 400)

  public formatNFDStatus(value: string | number): string {
    const status = parseInt(String(value), 10)
    if (status === 1) return 'one'
    if (status === 2) return 'two'
    if (status === 3) return 'three'
    if (status === 4) return 'four'
    if (status === 5) return 'five'
    return 'more'
  }

  public formatCrrnfdDurationMinutes(minutes: number): string {
    if (minutes == null || Number.isNaN(minutes)) {
      return '-'
    }
    let min = Math.max(0, Math.floor(minutes))
    const d = Math.floor(min / (24 * 60))
    min %= 24 * 60
    const h = Math.floor(min / 60)
    min %= 60
    const parts: string[] = []
    if (d) {
      parts.push(`${d}d`)
    }
    if (h) {
      parts.push(`${h}h`)
    }
    parts.push(`${min}m`)
    return parts.join(', ')
  }

  public shipmentTypeLabel(code: string): string {
    const key = String(code || '')
      .toLowerCase()
      .trim()
    return CRRNFD_SHIPMENT_TYPE_LABELS[key] || code || '—'
  }

  public mapsHref(lat: string, lon: string): string {
    const latLon = `${lat},${lon}`
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      latLon
    )}`
  }

  public waDigits(phone: string): string {
    return String(phone || '').replace(/\D/g, '')
  }

  public formatPhoneDisplay(phone: string): string {
    const raw = String(phone || '').trim()
    if (!raw) return ''
    const d = this.waDigits(raw)
    if (!d) return raw
    if (raw.startsWith('+')) return `+${d}`
    if (d.startsWith('62')) return `+${d}`
    if (d.startsWith('0')) return `+62${d.slice(1)}`
    return `+${d}`
  }

  public waSenderHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menghubungi terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  public waCourierHref(phone: string): string {
    const d = this.waDigits(phone)
    const q = encodeURIComponent(
      'Hi Bapak/Ibu, kami ingin menanyakan terkait pickup Lion Parcel.'
    )
    return d ? `https://api.whatsapp.com/send?phone=${d}&text=${q}` : '#'
  }

  @Watch('controller.pickupNfdList', { deep: true })
  onPickupNfdListChange(): void {
    const rows = this.controller.pickupNfdList.data || []
    const offset = (this.parameters.page - 1) * this.parameters.perPage
    this.tableData = rows.map((group: PickupNfdGroup, index: number) => {
      const clientLine =
        group.clientId != null && String(group.clientId) !== ''
          ? `(${group.clientId} - ${group.clientName || '-'})`
          : ''
      const lc = group.lastCourier
      return [
        this.tableCellMapper({ shipperHash: group.shipperHash }, '32px'),
        this.tableCellMapper(String(offset + index + 1), '60px'),
        this.tableCellMapper(
          {
            senderName: group.senderName,
            senderPhone: group.senderPhone,
            clientLine,
            shipperHash: group.shipperHash,
          },
          '200px',
          '16px'
        ),
        this.tableCellMapper(
          {
            shipperHash: group.shipperHash,
            totalShipments: group.totalShipments,
            totalQuantity: group.totalQuantity,
          },
          '160px'
        ),
        this.tableCellMapper(
          { label: this.shipmentTypeLabel(group.shipmentType) },
          '150px'
        ),
        this.tableCellMapper(
          {
            courierId: lc?.courierId ?? '',
            courierName: lc?.courierName ?? '',
            courierPhone: lc?.courierPhone ?? '',
            shipperHash: group.shipperHash,
          },
          '190px',
          '16px'
        ),
        this.tableCellMapper({ address: group.senderAddress, lon: group.longitude, lat: group.latitude, shipperHash: group.shipperHash }, '240px'),
        this.tableCellMapper(
          {
            date: Utils.formatDateWithIDLocale(group.crrnfdAt, 'DD MMM YYYY'),
            time: Utils.formatTimeZone(
              Utils.formatDateWithIDLocale(group.crrnfdAt, 'HH:mm Z')
            ),
          },
          '176px'
        ),
        this.tableCellMapper(
          {
            text: this.formatCrrnfdDurationMinutes(group.crrnfdDurationMinute),
          },
          '160px'
        ),
        this.tableCellMapper(
          { text: group.lastCancelReason || '—' },
          '214px'
        ),
        this.tableCellMapper({ iteration: group.crrnfdIteration || 0 }, '160px'),
        this.tableCellMapper({ shipperHash: group.shipperHash, shipmentType: group.shipmentType }, '64px'),
      ]
    })
    const valid = new Set(rows.map(g => g.shipperHash))
    this.selectedShipperHashes = this.selectedShipperHashes.filter(h =>
      valid.has(h)
    )
  }

  @Watch('parameters.page')
  @Watch('parameters.perPage')
  private clearRowSelectionOnPaginationChange(): void {
    this.selectedShipperHashes = []
    this.closeAturFlyout()
  }

  @Watch('headerCheckboxIndeterminate')
  private syncSelectAllCheckboxIndeterminate(): void {
    this.$nextTick(() => {
      const r = this.$refs.pickupCrrnfdSelectAllCheckbox as
        | HTMLInputElement
        | HTMLInputElement[]
        | undefined
      const el = Array.isArray(r) ? r[0] : r
      if (el) {
        el.indeterminate = this.headerCheckboxIndeterminate
      }
    })
  }

  public onToggleSelectAll(ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    const pageHashes = this.pageShipperHashes
    if (checked) {
      const merged = new Set([...this.selectedShipperHashes, ...pageHashes])
      this.selectedShipperHashes = [...merged]
    } else {
      const drop = new Set(pageHashes)
      this.selectedShipperHashes = this.selectedShipperHashes.filter(
        h => !drop.has(h)
      )
    }
  }

  public onToggleRowCheckbox(shipperHash: string, ev: Event): void {
    const checked = (ev.target as HTMLInputElement).checked
    if (checked) {
      if (!this.selectedShipperHashes.includes(shipperHash)) {
        this.selectedShipperHashes = [...this.selectedShipperHashes, shipperHash]
      }
    } else {
      this.selectedShipperHashes = this.selectedShipperHashes.filter(
        h => h !== shipperHash
      )
    }
  }

  public isRowSelected(shipperHash: string): boolean {
    return this.selectedShipperHashes.includes(shipperHash)
  }

  public closeAturMenus(): void {
    this.closeAturFlyout()
  }

  private closeAturFlyout(): void {
    this.unbindAturTableScrollListener()
    this.openAturMenuShipperHash = null
    this.openAturMenuShipmentType = null
    this.aturMenuTriggerEl = null
    this.aturMenuFixedStyle = {}
  }

  private updateAturMenuFixedPosition(): void {
    if (!this.aturMenuTriggerEl || !this.openAturMenuShipperHash) {
      return
    }
    const r = this.aturMenuTriggerEl.getBoundingClientRect()
    const w = this.aturMenuMinWidthPx
    const pad = 4
    let left = r.right - w
    const maxLeft = window.innerWidth - w - 8
    left = Math.max(8, Math.min(left, maxLeft))
    const top = r.bottom + pad
    this.aturMenuFixedStyle = {
      top: `${top}px`,
      left: `${left}px`,
    }
  }

  private bindAturTableScrollListener(): void {
    this.unbindAturTableScrollListener()
    const el = document.querySelector(
      '[data-testid="global-component-table-v2"]'
    )
    if (el) {
      this.aturTableScrollEl = el
      el.addEventListener('scroll', this.boundRepositionAturMenu, {
        passive: true,
      })
    }
  }

  private unbindAturTableScrollListener(): void {
    if (this.aturTableScrollEl) {
      this.aturTableScrollEl.removeEventListener(
        'scroll',
        this.boundRepositionAturMenu
      )
      this.aturTableScrollEl = null
    }
  }

  public onAturMenuToggle(data: any, ev: MouseEvent): void {
    if (this.openAturMenuShipperHash === data.shipperHash) {
      this.closeAturFlyout()
      return
    }
    this.openAturMenuShipperHash = data.shipperHash
    this.openAturMenuShipmentType = data.shipmentType
    this.aturMenuTriggerEl = ev.currentTarget as HTMLElement
    this.$nextTick(() => {
      this.updateAturMenuFixedPosition()
      this.bindAturTableScrollListener()
    })
  }

  public onAturFlyoutAction(action: string): void {
    const hash = this.openAturMenuShipperHash
    this.closeAturFlyout()
    if (!hash) return
    if (action === 'Manual Assign') {
      void this.$router.push({
        name: 'PickupCRRNFDManualAssignByShipper_V2',
        params: { shipperHash: hash },
      })
      return
    }
    if (action === 'Ubah ke CRRSRC') {
      this.modalCRRSRCVisible = true
      this.shipperHash = hash
    }
  }

  public async onBulkUbahSemuaCrrsrc(): Promise<void> {
    if (this.selectedShipperHashes.length === 0) return
    await this.runShipperHashToCrrsrc([...this.selectedShipperHashes])
  }

  async runShipperHashToCrrsrc(hashes: string[]): Promise<void> {
    try {
      const results = await this.controller.postPickupNfdShipperHashToCrrsrc(
        hashes
      )
      const ok = results.filter(r => r.isSuccess)
      const fail = results.filter(r => !r.isSuccess)
      if (results.length === 0) {
        Vue.notify({
          title: 'Ubah ke CRRSRC',
          text: 'Permintaan telah diproses.',
          type: 'success',
          duration: 5000,
        })
      } else if (fail.length === 0 && ok.length > 0) {
        this.modalSuccessCRRSRCVisible = true
      } else if (ok.length === 0) {
        Vue.notify({
          title: 'Ubah ke CRRSRC',
          text:
            fail.map(f => `${f.message || 'Gagal'}`).join('; ') ||
            'Semua pengirim gagal diubah.',
          type: 'error',
          duration: 8000,
        })
      } else {
        Vue.notify({
          title: 'Ubah ke CRRSRC',
          text: `Berhasil ${ok.length}, gagal ${fail.length}.`,
          type: 'warn',
          duration: 8000,
        })
      }
      this.selectedShipperHashes = []
      this.shipperHash = ""
      await this.fetchPickup(true)
    } catch {
      /* notified in controller */
    }
  }

  public onTotalShipmentKoliClick(data: {
    shipperHash: string
    totalShipments: number
    totalQuantity: number
  }): void {
    this.shipmentListModalShipperHash = data.shipperHash
    this.shipmentListModalVisible = true
  }

  public closeShipmentListModal(): void {
    this.shipmentListModalVisible = false
    this.shipmentListModalShipperHash = ''
    this.controller.clearPickupNfdShipperHashDetail()
  }

  public onOpenBulkAssignModal(): void {
    if (this.selectedShipperHashes.length === 0) return
    this.bulkAssignModalVisible = true
    this.controller.getCourierList({
      perPage: 30,
      courierStatus: 'ACTIVE',
      driverType: 'KVP%3BPOS'
    })
  }

  public onBulkAssignCourierSearch = Utils.debounce((search: string) => {
    const q = search === '' ? undefined : search
    this.controller.getCourierList({
      perPage: 30,
      q,
      courierStatus: 'ACTIVE',
      driverType: 'KVP%3BPOS'
    })
  }, 500)

  public closeBulkAssignModal(): void {
    if (this.bulkAssignSubmitting) return
    this.bulkAssignModalVisible = false
  }

  public async onBulkAssignConfirm(payload: {
    courierId: number
    manualAssignDate?: string
    timeZone?: string
  }): Promise<void> {
    if (this.selectedShipperHashes.length === 0) return
    this.bulkAssignSubmitting = true
    try {
      const ids = this.selectedShipperHashes.length ? this.selectedShipperHashes.map((item: string) => {
        const totalShipment = this.controller.pickupNfdList.data.find((g) => g.shipperHash === item)?.totalShipments || 0
        return new PickupAssignIds(
          item,
          totalShipment
        )
      }) : []
      const results = await this.controller.manualAssignPickupBulkLiberta({
        shipperHashes: [...ids],
        courierId: payload.courierId,
        manualAssignDate: payload.manualAssignDate,
        timeZone: payload.timeZone,
      })
      const ok = results.filter(r => r.isSuccess)
      const fail = results.filter(r => !r.isSuccess)
      if (results.length === 0) {
        Vue.notify({
          title: 'Assign banyak ke kurir',
          text: 'Permintaan assign berhasil dikirim.',
          type: 'success',
          duration: 5000,
        })
      } else if (fail.length === 0) {
        Vue.notify({
          title: 'Assign banyak ke kurir',
          text: 'Semua pengirim berhasil ditugaskan.',
          type: 'success',
          duration: 5000,
        })
      } else if (ok.length === 0) {
        Vue.notify({
          title: 'Assign banyak ke kurir',
          text:
            fail
              .map(f => `${f.message || 'Gagal'}`)
              .join('; ') || 'Semua pengirim gagal.',
          type: 'error',
          duration: 8000,
        })
      } else {
        Vue.notify({
          title: 'Assign banyak ke kurir',
          text: `Berhasil ${ok.length}, gagal ${fail.length}.`,
          type: 'warn',
          duration: 8000,
        })
      }
      this.bulkAssignModalVisible = false
      this.selectedShipperHashes = []
      await this.fetchPickup(true)
      await this.fetchAssignPickupBulkHistoryList()
    } catch {
      /* notified in controller */
      this.bulkAssignModalVisible = false
      this.selectedShipperHashes = []
      await this.fetchPickup(true)
    } finally {
      this.bulkAssignSubmitting = false
    }
  }

  public onHeaderSort(sortName: string): void {
    const cur = this.parameters.sort
    if (!cur.direction && !cur.name) {
      this.onDataTableSort({ direction: 'ASC', name: sortName })
    } else if (sortName === cur.name) {
      if (cur.direction === 'ASC') {
        this.onDataTableSort({ direction: 'DESC', name: sortName })
      } else if (cur.direction === 'DESC') {
        this.onDataTableSort({ direction: '', name: '' })
      }
    } else {
      this.onDataTableSort({ direction: 'ASC', name: sortName })
    }
  }

  public isHeaderSortDirection(direction: 'ASC' | 'DESC', sortName: string): boolean {
    return (
      this.parameters.sort.name === sortName &&
      this.parameters.sort.direction === direction
    )
  }

  get isRowCorporate(): boolean {
    return this.openAturMenuShipmentType === "aggregator";
  }

  public async fetchAssignPickupBulkHistoryList(): Promise<void> {
    this.controller.setLoading(true)
    try {
      await this.controller.fetchAssignPickupBulkHistoryList({})
    } finally {
      this.controller.setLoading(false)
    }
  }

  get assignPickupBulkHistoryList(): AssignPickupBulkHistoryList {
    return this.controller.assignPickupBulkHistoryList
  }

  get descriptionTotalAssignPickup(): string {
    const { totalProcess, totalSuccess, totalFailed } =
      this.assignPickupBulkHistoryList.pagination;

    const data = [
      totalProcess ? `${totalProcess} Diproses` : "",
      totalSuccess ? `${totalSuccess} Berhasil` : "",
      totalFailed ? `${totalFailed} Gagal` : "",
    ]
      .filter(Boolean)
      .join(", ");

    return data || "-"
  }

  public async onReadAssignPickupBulkHistory(shipperHashes: string[]): Promise<void> {
    this.controller.setLoading(true)
    try {
      await this.controller.readAssignPickupBulkHistory({
        shipperHashes: shipperHashes
      })
    } finally {
      this.controller.setLoading(false)
    }
  }

  public async closeAssignPickupBulktModal(shipperHashes: string[]): Promise<void> {
    this.modalAssignPickupBulkVisible = false

    try {
      if (shipperHashes.length) {
        await this.onReadAssignPickupBulkHistory(shipperHashes);
      }
    } finally {
      this.fetchAssignPickupBulkHistoryList();
    }
  }

  async showPhoneNumber(resource: string, resourceId: string, field: string, hash: string, type: string): Promise<void> {
    try {
      const resp =  await this.controller.adminContactShow({
        resource: resource,
        resourceId: resourceId,
        field: field,
        source: "pickup_nfd_v2"
      });
      const list = this.controller.pickupNfdList.data.map((item) => {
        if (item.shipperHash === hash) {
          if (type === "senderPhone") {
            item.senderPhone = resp.value || "-"
          } else if (type === "senderAddress") {
            item.senderAddress = resp.value || "-"
          } else if (type === "courierPhone") {
            if (item.lastCourier) item.lastCourier.courierPhone = resp.value || "-"
          }
          return item
        }

        return item
      });
      this.controller.pickupNfdList.data = list
    } finally {
      // no loading
    }
  }

  hidePhoneNumber(hash: string, type: string): void {
    const list = this.controller.pickupNfdList.data.map((item) => {
      if (item.shipperHash === hash) {
        if (type === "senderPhone") {
          item.senderPhone = ""
        } else if (type === "senderAddress") {
          item.senderAddress = ""
        } else if (type === "courierPhone") {
          if (item.lastCourier) item.lastCourier.courierPhone = ""
        }
        return item
      }

      return item
    });
    this.controller.pickupNfdList.data = list
  }
}
export default PickupCRRNFDList;
